import { createSlice } from '@reduxjs/toolkit';
import { addItemToList, deleteListItem, sar, updateOneItemInList } from '../../../helpers/reduxHelper';

const getInitialState = () => ({
  selectedCameraId: null,
  cameraPresets: [],
  editCameraData: null,
  loading: false,
  loaded: false,
  error: false,
})

const configuratorCamera = createSlice({
  name: 'configuratorCamera',
  initialState: getInitialState,
  reducers: {
    resetState: () => {
      return getInitialState();
    },
    setEditCameraData: sar('editCameraData'),
    setCameraPresets: sar('cameraPresets'),
    setSelectedCameraId: sar('selectedCameraId'),
    setLoaded: sar('loaded'),
    updateCameraPreset: updateOneItemInList('cameraPresets'),
    addCameraPreset: addItemToList('cameraPresets'),
    deleteCameraPreset: deleteListItem('cameraPresets'),
    fetchCameraPresetsStart: (state) => {
      state.cameraPresets = [];
      state.loading = true;
      state.loaded = false;
      state.error = false;
    },
    fetchCameraPresetsSuccess: (state, { payload }) => {
      state.cameraPresets = payload;
      state.loading = false;
      state.loaded = true;
      state.error = false;
    },
    fetchCameraPresetsFailed: (state) => {
      state.cameraPresets = [];
      state.loading = false;
      state.loaded = true;
      state.error = true;
    },
  },
});

export const configuratorCameraActions = configuratorCamera.actions;
export const configuratorCameraReducer = configuratorCamera.reducer;
export default configuratorCameraReducer;

export const selectSelectedCameraId = (state) => state.configuratorCamera.selectedCameraId;
export const selectCameraPresets = (state) => state.configuratorCamera.cameraPresets;
export const selectCameraPreset = (id) => (state) => state.configuratorCamera.cameraPresets.find(c => c.id === id);
export const selectEditCameraData = (state) => state.configuratorCamera.editCameraData;
export const isEditCameraActive = (state) => Boolean(selectEditCameraData(state));
export const selectIsCameraPresetsLoading = (state) => state.configuratorCamera.loading;
export const selectIsCameraPresetsLoaded = (state) => state.configuratorCamera.loaded;
export const selectFailedToLoadCameraPrests = (state) => state.configuratorCamera.error;
